import Auth0Lock from 'auth0-lock';
import { merge } from 'lodash';
import { EnvVars, get } from '../config';
var AUTH0_ID_TOKEN = 'auth-id-token';
var AUTH0_ACCESS_TOKEN = 'auth-access-token';
var REFERRER = 'redirect-to-referrer';
var logo = 'https://s3.amazonaws.com/indigo-artifacts-production/shared-images/color-transparent-background.png';
var DEFAULT_AUTH0_OPTIONS = {
    allowSignUp: false,
    allowedConnections: ['indigoag-waad', 'Username-Password-Authentication'],
    auth: {
        params: { scope: 'openid offline-access email' },
        redirect: true,
        responseType: 'token id_token',
    },
    autofocus: true,
    avatar: { url: function () { return ({}); }, displayName: function () { return ({}); } },
    configurationBaseUrl: 'https://cdn.auth0.com',
    container: 'login',
    languageDictionary: {
        title: '',
        blankErrorHint: 'Required',
    },
    rememberLastLogin: false,
    theme: {
        logo: logo,
        primaryColor: '#00577d',
    },
};
var AuthService = /** @class */ (function () {
    function AuthService() {
    }
    AuthService.getAccessToken = function () {
        return localStorage.getItem(AUTH0_ACCESS_TOKEN) || '';
    };
    AuthService.setAccessToken = function (token) {
        localStorage.setItem(AUTH0_ACCESS_TOKEN, token);
    };
    AuthService.getIdToken = function () {
        return localStorage.getItem(AUTH0_ID_TOKEN) || '';
    };
    AuthService.setIdToken = function (token) {
        localStorage.setItem(AUTH0_ID_TOKEN, token);
    };
    AuthService.clearTokens = function () {
        localStorage.removeItem(AUTH0_ACCESS_TOKEN);
        localStorage.removeItem(AUTH0_ID_TOKEN);
    };
    AuthService.getReferrer = function () {
        return localStorage.getItem(REFERRER) || '';
    };
    AuthService.setReferrer = function (referrer) {
        localStorage.setItem(REFERRER, referrer);
    };
    AuthService.getLock = function (AUTH0_OPTIONS) {
        if (AUTH0_OPTIONS === void 0) { AUTH0_OPTIONS = DEFAULT_AUTH0_OPTIONS; }
        var options = merge({}, DEFAULT_AUTH0_OPTIONS, AUTH0_OPTIONS);
        return new Auth0Lock(get(EnvVars.AUTH0_CLIENTID), get(EnvVars.AUTH0_DOMAIN), options);
    };
    return AuthService;
}());
export { AuthService, AUTH0_ACCESS_TOKEN, AUTH0_ID_TOKEN, REFERRER };
//# sourceMappingURL=auth.js.map